import angular from 'angular'
import moment from 'moment-timezone'

angular
  .module('admin.daily_login_banners.edit', [])
  .controller('DailyLoginBannerEditCtrl', DailyLoginBannerEditCtrl)

/** @ngInject */
function DailyLoginBannerEditCtrl(
  $scope,
  $state,
  $timeout,
  $stateParams,
  DailyLoginBannerService,
  UploadService,
) {
  var vm = this

  vm.model = {}
  vm.pathImgH = ''
  vm.pathImgM = ''
  vm.id = $stateParams.id
  vm.isOpen = false
  vm.isOpen2 = false

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()
    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()
    vm.isOpen2 = true
  }

  function load() {
    if (vm.id !== '0') {
      DailyLoginBannerService.get(vm.id).then(function (result) {
        vm.model = result.results

        // Start Date
        if (vm.model['ts-start']) {
          vm.data1 = new Date(vm.model['ts-start'] / 1000)
        } else {
          vm.data1 = null
        }

        // End Date
        if (vm.model['ts-end']) {
          vm.data2 = new Date(vm.model['ts-end'] / 1000)
        } else {
          vm.data2 = null
        }
      })
    } else {
      vm.data1 = null
      vm.data2 = null
    }
  }

  load()

  vm.save = function () {
    var model = angular.copy(vm.model)
    delete model.ts
    // Start Date
    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-start'] = null
    }
    // End Date
    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-end'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-end'] = null
    }

    console.log(model, model.id)
    var isUpdate = model.id && model.id !== 0
    // Wrap in $scope.$apply() to ensure digest cycle
    $scope.$applyAsync(() => {
      if (isUpdate) {
        DailyLoginBannerService.update(model.id, model)
          .then(() => $state.go('admin.daily_login_banners'))
          .catch((err) => swal(err?.error?.message || 'Update failed', '', 'error'))
      } else {
        DailyLoginBannerService.create(model)
          .then(() => $state.go('admin.daily_login_banners'))
          .catch((err) => swal(err?.error?.message || 'Create failed', '', 'error'))
      }
    })
  }

  vm.cancel = function () {
    $state.go('admin.daily_login_banners')
  }

  vm.uploadH = function (item) {
    if (!vm.pathImgH || vm.pathImgH.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadH = true
    let uploadId = item.id || 0 // Use 0 for new items
    UploadService.save('daily_login_banners', vm.pathImgH, 'img-web', uploadId).then((fileName) => {
      vm.loadH = false
      $scope.$applyAsync(() => {
        item['img-web'] = fileName
      })
    })
  }
  vm.uploadM = function (item) {
    if (!vm.pathImgM || vm.pathImgM.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadM = true
    let uploadId = item.id || 0
    UploadService.save('daily_login_banners', vm.pathImgM, 'img-mob', uploadId).then((fileName) => {
      vm.loadM = false
      $scope.$applyAsync(() => {
        item['img-mob'] = fileName
      })
    })
  }

  // Watchers for timezone display
  var watch1 = $scope.$watch('vm.data1', function (newVal) {
    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    } else {
      vm.timezoneDate1NY = null
      vm.timezoneDate1LA = null
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal) {
    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    } else {
      vm.timezoneDate2NY = null
      vm.timezoneDate2LA = null
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })
}
